export default {"src":"/_next/static/media/feedly.920389ae.svg","height":18,"width":20,"blurWidth":0,"blurHeight":0};